export default __webpack_public_path__ + "bfgoodrich.553d8d.svg";